angular.module("persons_gifts")

    .controller("PersonsGiftsListCtrl", ['LoginService', '$rootScope', '$scope', 'Restangular', 'gridService', 'modalService', '$uibModal', '$filter', '$translate','$state', 'datasetsService', 'logService',
        function (LoginService, $rootScope, $scope, Restangular, gridService, modalService, $uibModal, $filter, $translate, $state, datasetsService, logService) {
        
        //Comprobamos si tiene permiso escritura
            $scope.allowWrite = LoginService.permissionExist("PERSONS_GIFTS_WRITE");

        $rootScope.title = $filter('translate')('persons_gifts.title');
        $rootScope.breadcrumb = [
            { title: $filter('translate')('persons_gifts.title') }
        ];

        $scope.search = {
            in_out: 'OUT', 
            from_person: null,
            to_person: null,
            event_name: null,
            gift_name: null,
            quantity: null,
            notes: null
        };


        $scope.gridOptionsPersonsGiftsIn = {
            pdfTitle: $filter('translate')('persons_gifts.in_gifts'),
            exporterMenuCsv: false,
            exporterMenuPdf: false,
            exporterMenuExcel: false,
            enableGridMenu: false,
            gridMenuShowHideColumns: false,
            enableSorting: true,            
            paginationPageSizes: [20, 40, 60],
            paginationPageSize: 20,
            rowTemplate: '<div ng-dblclick="grid.appScope.goToEdit(row.entity)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" class="ui-grid-cell" ng-class="col.colIndex()" ui-grid-cell style="cursor:pointer;"></div>',
            onRegisterApi: function (gridApi) {
                this.gridApi = gridApi;
            },
            exporterFieldCallback: function (grid, row, col, value) {
                if (col.name == "from_name") {
                    if (row.entity.from_person_id != null) {
                        return row.entity.FK_persons_gifts_persons1.surname + " " + (row.entity.FK_persons_gifts_persons1.lastname != null ? row.entity.FK_persons_gifts_persons1.lastname : "") + ", " + row.entity.FK_persons_gifts_persons1.name;
                    } else {
                        return row.entity.from_name;
                    }
                }
                if (col.name == "to_name") {
                    if (row.entity.to_person_id != null) {
                        return row.entity.FK_persons_gifts_persons.surname + " " + (row.entity.FK_persons_gifts_persons.lastname != null ? row.entity.FK_persons_gifts_persons.lastname : "") + ", " + row.entity.FK_persons_gifts_persons.name;
                    } else {
                        return row.entity.to_name;
                    }
                }

                return value;
            },

            columnDefs: [
              { name: 'id', visible: false, enableHiding: false, exporterSuppressExport: true },
              {
                  name: 'gift_date', width: 100, displayName: $filter('translate')('persons_gifts.gift_date'), cellFilter: 'toLocalDate | date:\'dd/MM/yyyy\'',
                  filterHeaderTemplate: '<div class="ui-grid-filter-container">' + 
                       $filter('translate')('persons_gifts.date_from') + '<input ui-date="{ dateFormat: \'dd/mm/yy\' }" ng-change="grid.appScope.gridOptionsPersonsGiftsIn.gridApi.core.raise.itemChanged(grid.appScope);" class="form-control" id="dateFrom" ng-model="grid.appScope.person_gift.dateFrom" required>' +
                       $filter('translate')('persons_gifts.date_to') + '<input ui-date="{ dateFormat: \'dd/mm/yy\' }" ng-change="grid.appScope.gridOptionsPersonsGiftsIn.gridApi.core.raise.itemChanged(grid.appScope);" class="form-control" id="dateTo" ng-model="grid.appScope.person_gift.dateTo" required>' +
                   '</div>',
                  enableFiltering: true, enableColumnMenu: false,
                  customFormatFn: function (value) {
                      var fecha = new Date(value);
                      return $filter('date')(fecha, 'dd/MM/yyyy');
                  },
                },
                {
                    name: 'from_name', field: 'from_name', displayName: $filter('translate')('persons_gifts.from_name'), enableFiltering: true, enableHiding: false,
                    cellTemplate: '<div class="ui-grid-cell-contents"><div ng-if="row.entity.from_person_id!=null">{{row.entity.FK_persons_gifts_persons1.surname}} {{row.entity.FK_persons_gifts_persons1.lastname}}, {{row.entity.FK_persons_gifts_persons1.name}}</div><div ng-if="row.entity.from_person_id==null">{{row.entity.from_name}}</div></div>',
                },
                {
                    name: 'to_name', field: 'to_name',
                    displayName: $filter('translate')('persons_gifts.person_to'), enableFiltering: true, enableHiding: false,
                    cellTemplate: '<div class="ui-grid-cell-contents"><div ng-if="row.entity.to_person_id!=null">{{row.entity.FK_persons_gifts_persons.surname}} {{row.entity.FK_persons_gifts_persons.lastname}}, {{row.entity.FK_persons_gifts_persons.name}}</div><div ng-if="row.entity.to_person_id==null">{{row.entity.to_name}}</div></div>',
                },
             // { name: 'person_lastname', field: 'FK_persons_gifts_persons.lastname', displayName: $filter('translate')('persons_gifts.person_lastname'), enableFiltering: true, enableHiding: false },
              { name: 'event_name', field: 'FK_persons_gifts_events.name', displayName: $filter('translate')('persons_gifts.event'), enableFiltering: true, enableHiding: false },
              { name: 'gift_name', field: 'name', displayName: $filter('translate')('persons_gifts.gift'), enableFiltering: true, enableHiding: false },
                { name: 'quantity', width: 80, displayName: $filter('translate')('persons_gifts.quantity'), enableFiltering: true, enableHiding: false },
                { name: 'notes', displayName: $filter('translate')('persons_gifts.notes'), enableFiltering: true, enableHiding: false },
              {
                  name: ' ', width: 150, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionTemplate([
                      { title: $filter('translate')('persons_gifts.button_edit'), action: 'ui-sref="persons_gifts.edit({in_out:grid.appScope.person_gift.in_out, id:row.entity.id})"', cssIconClass: "fa fa-edit" },
                      { title: $filter('translate')('persons_gifts.button_delete'), action: 'ng-click="grid.appScope.deleteInDialog(row.entity.id,row.entity.FK_persons_gifts_persons.name, row.entity.FK_persons_gifts_persons.surname);" ng-if="grid.appScope.allowWrite"', cssIconClass: "fa fa-remove" }
                  ], { cssClass: "pull-right" })
              },
            ],
            getData: function (options) {
                options.in_out = 'IN';
                options.gift_date_from = $scope.search.date_from;
                options.gift_date_to = $scope.search.date_to;
                options.event_name = $scope.search.event_name;
                options.gift_name = $scope.search.gift_name;
                options.quantity = $scope.search.quantity;
                options.from_name = $scope.search.from_name;
                options.to_name = $scope.search.to_name;
                options.notes = $scope.search.notes; 
                return Restangular.all('PersonsGifts').getList(options);
            }
        };

        $scope.goToEdit = function (rowEntity) {

            if (angular.isUndefined(rowEntity.in_out)) {
                rowEntity.in_out = $scope.search.in_out;
            }

            $state.go("persons_gifts.edit", { in_out: rowEntity.in_out, id: rowEntity.id });

        }

        $scope.deleteInDialog = function (id, name, surname) {
            $scope.id = id;
            modalService.confirm({
                title: $filter('translate')('persons_gifts.button_delete'),
                message: $filter('translate')('persons_gifts.delete_message') + " " + name +" "+ surname+"?",
                onAccept: function () {
                    Restangular.one('PersonsGifts', $scope.id).remove().then(function () {
                        toastr.success($filter('translate')('persons_gifts.delete_success'));
                        $scope.gridOptionsPersonsGiftsIn.gridApi.core.raise.itemDeleted($scope);
                        
                    }, function (response) {
                        $scope.errorMessage = response.message;
                    });
                }
            });

        };
        
        $scope.gridOptionsPersonsGiftsOut = {
            pdfTitle: $filter('translate')('persons_gifts.out_gifts'),
            exporterMenuCsv: false,
            exporterMenuPdf: false,
            exporterMenuExcel: false,
            enableGridMenu: false,
            gridMenuShowHideColumns: false,
            enableSorting: true,
            paginationPageSizes: [20, 40, 60],
            paginationPageSize: 20,
            rowTemplate: '<div ng-dblclick="grid.appScope.goToEdit(row.entity)"  ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" class="ui-grid-cell" ng-class="col.colIndex()" ui-grid-cell style="cursor:pointer;"></div>',
            onRegisterApi: function (gridApi) {
                this.gridApi = gridApi;
            },
            exporterFieldCallback: function (grid, row, col, value) {
                if (col.name == "from_name") {
                    if (row.entity.from_person_id != null) {
                        return row.entity.FK_persons_gifts_persons1.surname + " " + (row.entity.FK_persons_gifts_persons1.lastname != null ? row.entity.FK_persons_gifts_persons1.lastname : "") + ", " + row.entity.FK_persons_gifts_persons1.name;
                    } else {
                        return row.entity.from_name;
                    }
                }
                if (col.name == "to_name") {
                    if (row.entity.to_person_id != null) {
                        return row.entity.FK_persons_gifts_persons.surname + " " + (row.entity.FK_persons_gifts_persons.lastname != null ? row.entity.FK_persons_gifts_persons.lastname : "") + ", " + row.entity.FK_persons_gifts_persons.name;
                    } else {
                        return row.entity.to_name;
                    }
                }

                return value;
            },

            columnDefs: [
              { name: 'id', visible: false, enableHiding: false, exporterSuppressExport: true },
              {
                  name: 'gift_date',width: 100, displayName: $filter('translate')('persons_gifts.gift_date'), cellFilter: 'toLocalDate | date:\'dd/MM/yyyy\'',
                  filterHeaderTemplate: '<div class="ui-grid-filter-container">' +
                       $filter('translate')('persons_gifts.date_from') + '<input ui-date="{ dateFormat: \'dd/mm/yy\' }" ng-change="grid.appScope.gridOptionsPersonsGiftsOut.gridApi.core.raise.itemChanged(grid.appScope);" class="form-control" id="date_from" ng-model="grid.appScope.dateFrom" required>' +
                       $filter('translate')('persons_gifts.date_to') + '<input ui-date="{ dateFormat: \'dd/mm/yy\' }" ng-change="grid.appScope.gridOptionsPersonsGiftsOut.gridApi.core.raise.itemChanged(grid.appScope);" class="form-control" id="date_to" ng-model="grid.appScope.dateTo" required>' +
                   '</div>',
                  enableFiltering: true, enableColumnMenu: false,
                  customFormatFn: function (value) {
                      var fecha = new Date(value);
                      return $filter('date')(fecha, 'dd/MM/yyyy');
                  },
                },
                {
                    name: 'from_name', field: 'from_name', displayName: $filter('translate')('persons_gifts.from_name'), enableFiltering: true, enableHiding: false,
                    cellTemplate: '<div class="ui-grid-cell-contents"><div ng-if="row.entity.from_person_id!=null">{{row.entity.FK_persons_gifts_persons1.surname}} {{row.entity.FK_persons_gifts_persons1.lastname}}, {{row.entity.FK_persons_gifts_persons1.name}}</div><div ng-if="row.entity.from_person_id==null">{{row.entity.from_name}}</div></div>',
                },
                {
                    name: 'to_name', field: 'to_name',
                    displayName: $filter('translate')('persons_gifts.person_to'), enableFiltering: true, enableHiding: false,
                    cellTemplate: '<div class="ui-grid-cell-contents"><div ng-if="row.entity.to_person_id!=null">{{row.entity.FK_persons_gifts_persons.surname}} {{row.entity.FK_persons_gifts_persons.lastname}}, {{row.entity.FK_persons_gifts_persons.name}}</div><div ng-if="row.entity.to_person_id==null">{{row.entity.to_name}}</div></div>',
                },
              //{ name: 'person_name', field: 'FK_persons_gifts_persons.name', displayName: $filter('translate')('persons_gifts.person_name'), enableFiltering: true, enableHiding: false },
              //{ name: 'person_surname', field: 'FK_persons_gifts_persons.surname', displayName: $filter('translate')('persons_gifts.person_surname'), enableFiltering: true, enableHiding: false },
             // { name: 'person_lastname', field: 'FK_persons_gifts_persons.lastname', displayName: $filter('translate')('persons_gifts.person_lastname'), enableFiltering: true, enableHiding: false },
              { name: 'event_name', field: 'FK_persons_gifts_events.name', displayName: $filter('translate')('persons_gifts.event'), enableFiltering: true, enableHiding: false },
              { name: 'gift_name', field: 'name', displayName: $filter('translate')('persons_gifts.gift'), enableFiltering: true, enableHiding: false },
                { name: 'quantity', width: 80, displayName: $filter('translate')('persons_gifts.quantity'), enableFiltering: true, enableHiding: false },
                { name: 'notes', displayName: $filter('translate')('persons_gifts.notes'), enableFiltering: true, enableHiding: false },
              {
                  name: ' ', width: 150, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionTemplate([
                      { title: $filter('translate')('persons_gifts.button_edit'), action: 'ui-sref="persons_gifts.edit({in_out:grid.appScope.person_gift.in_out, id:row.entity.id})"', cssIconClass: "fa fa-edit" },
                      { title: $filter('translate')('persons_gifts.button_delete'), action: 'ng-click="grid.appScope.deleteOutDialog(row.entity.id,row.entity.FK_persons_gifts_persons.name);" ng-if="grid.appScope.allowWrite"', cssIconClass: "fa fa-remove" }
                  ], { cssClass: "pull-right" })
              },
            ],
            getData: function (options) {
                options.in_out = 'OUT';
                options.gift_date_from = $scope.search.date_from;
                options.gift_date_to = $scope.search.date_to;
                options.event_name = $scope.search.event_name;
                options.gift_name = $scope.search.gift_name;
                options.quantity = $scope.search.quantity;
                options.from_name = $scope.search.from_name;
                options.to_name = $scope.search.to_name;
                options.notes = $scope.search.notes; 


                return Restangular.all('PersonsGifts').getList(options);
            }
        };

        $scope.deleteOutDialog = function (id, name) {            
            $scope.id = id;
            logService.debug(name);
            modalService.confirm({
                title: $filter('translate')('persons_gifts.button_delete'),
                message: $filter('translate')('persons_gifts.delete_message') + " " + name + "?",
                onAccept: function () {
                    Restangular.one('PersonsGifts', $scope.id).remove().then(function () {
                        toastr.success($filter('translate')('persons_gifts.delete_success'));
                        $scope.gridOptionsPersonsGiftsOut.gridApi.core.raise.itemDeleted($scope);

                    }, function (response) {
                        $scope.errorMessage = response.message;
                    });
                }
            });

        };

        $scope.export = function () {
            var options = {
                filters: {
                    IN_OUT: $scope.search.in_out,
                    GIFT_DATE_FROM: $scope.search.date_from,
                    GIFT_DATE_TO: $scope.search.date_to,
                    FROM_NAME: $scope.search.from_name,
                    TO_NAME: $scope.search.to_name,
                    EVENT_NAME: $scope.search.event_name,
                    GIFT_NAME: $scope.search.gift_name,
                    QUANTITY: $scope.search.quantity,
                    NOTES: $scope.search.notes
                }
            };

        datasetsService.exportByType("persons_gifts", options);
        };

        $scope.clearForm = function () {
            $scope.search = { in_out: 'OUT' };
            $scope.gridOptionsPersonsGiftsOut.loadData();
        }

        $scope.searchData = function () {
            $scope.gridOptionsPersonsGiftsOut.loadData();
            $scope.gridOptionsPersonsGiftsIn.loadData();

        }

        $scope.changeINOUT = function (in_out) {
            $scope.search.in_out = in_out;
        }
        
    }])

;